<template>
    <div class="page">
        <!-- 搜索 -->
<!--        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"-->
<!--                 class="query-form" @submit.native.prevent>-->
<!--            <el-form-item label="名称">-->
<!--                <el-input v-model="queryForm.categoryName"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="父ID">-->
<!--                <el-input v-model="queryForm.parentId"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item>-->
<!--                <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseCategoryList">查询-->
<!--                </el-button>-->
<!--                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>-->
<!--            </el-form-item>-->
<!--        </el-form>-->
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addEduCourseCategory"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editEduCourseCategory(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteEduCourseCategory(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
<!--                    <span-->
<!--                        title="搜索"-->
<!--                        class="icon-box"-->
<!--                        @click="search"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <Search />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportEduCourseCategoryList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class="icon-box"
                        @click="refreshEduCourseCategoryList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="eduCourseCategoryList"
                row-key="id"
                height="100%"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    prop="categoryName"
                    label="名称"
                ></el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="parentId"-->
<!--                    label="父ID"-->
<!--                ></el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="sort"
                    label="排序"
                >
                    <template slot-scope="scop">
                        <el-input-number
                            style="width:150px"
                            v-model="scop.row.sort"
                            @change="changeSort(scop.row)"
                            size="small"
                            label=""
                            :min="1"
                            :max="1000"
                            :step="1"
                            :controls="true"
                            controls-position="both"
                        >
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="340"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkEduCourseCategory(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editEduCourseCategory(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteEduCourseCategory(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                            <div @click="addChildCourseCategory(scop.row.id)">
                                <Icon size="16">
                                    <AddCircle24Regular />
                                </Icon>
                                <span class="operation-label">添加下级商品分类</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
<!--            <div class="pagination-box">-->
<!--                <el-pagination-->
<!--                    @size-change="sizeChange"-->
<!--                    @current-change="currentChange"-->
<!--                    :current-page.sync="currentPage"-->
<!--                    :page-sizes="[10, 20, 50, 100]"-->
<!--                    :page-size="pageSize"-->
<!--                    layout="total, sizes, prev, pager, next, jumper"-->
<!--                    :total="totalNum"-->
<!--                    background-->
<!--                    :pager-count="7"-->
<!--                >-->
<!--                </el-pagination>-->
<!--            </div>-->
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="eduCourseCategoryStates[eduCourseCategoryState]"
                :visible.sync="showDialog"
                width="400px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="eduCourseCategory"
                        ref="eduCourseCategoryForm"
                        :rules="rules"
                        label-width="60px"
                        :inline="true"
                        size="mini"
                    >
                        <el-form-item
                            label="名称"
                            prop="categoryName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="eduCourseCategory.categoryName"
                                :disabled="eduCourseCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="父ID"
                            prop="parentId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="eduCourseCategory.parentId"-->
<!--                                :disabled="eduCourseCategoryState == 'check'"-->
<!--                            ></el-input>-->
                            <el-select
                                clearable
                                style="width: 200px"
                                v-model="eduCourseCategory.parentId"
                                :disabled="eduCourseCategoryState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-tree
                                    :data="eduCourseCategoryList"
                                    :props="treeProps"
                                    :render-after-expand="false"
                                >
                                    <div
                                        class="custom-tree-node flex items-center"
                                        slot-scope="{ node, data }"
                                    >
                                        <el-option
                                            :label="node.label"
                                            :value="data.id"
                                        > </el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="排序"
                            prop="sort"
                        >
                            <el-input-number
                                style="width: 200px"
                                :disabled="eduCourseCategoryState == 'check'"
                                v-model="eduCourseCategory.sort"
                                size="small"
                                label=""
                                :min="1"
                                :max="100000"
                                :step="1"
                                :controls="true"
                                controls-position="both"
                            >
                            </el-input-number>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="eduCourseCategoryState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, AddCircle24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        AddCircle24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetEduCourseCategoryList();
                this.getEduCourseCategoryList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetEduCourseCategoryList();
                this.getEduCourseCategoryList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                categoryName: '', //名称
                parentId: '', //父ID
                sort: '' //排序
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            eduCourseCategoryState: 'add',
            eduCourseCategoryStates: {
                add: '新建课程分类',
                check: '查看课程分类',
                edit: '修改课程分类'
            },
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            multipleSelection: [],
            eduCourseCategoryList: [],
            eduCourseCategory: {
                categoryName: '', //名称
                parentId: '', //父ID
                sort: '' //排序
            },
            btnLoading: false,

            rules: {
                categoryName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                // parentId: [{ required: true, message: '父ID不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getEduCourseCategoryList();
    },
    methods: {
        changeSort(category) {
            delete category.children
            delete category.updateTime
            post(`/edu/coursecategory/edit`, { ...category }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.getEduCourseCategoryList();
                }
            });
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetEduCourseCategoryList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.eduCourseCategoryList = [];
        },
        resetDialog() {
            this.eduCourseCategoryState = 'add';
            this.showDialog = false;
            this.queryForm = {
                categoryName: '', //名称
                parentId: '', //父ID
                sort: '' //排序
            };
            this.getEduCourseCategoryList();
        },
        closeDialog() {
            this.showDialog = false;
            this.eduCourseCategory = {
                categoryName: '', //名称
                parentId: '', //父ID
                sort: '' //排序
            };
        },
        submitForm() {
            if (this.eduCourseCategoryState == 'add') {
                this.$refs.eduCourseCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/edu/coursecategory/add`, { ...this.eduCourseCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCategoryList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.eduCourseCategoryState == 'edit') {
                this.$refs.eduCourseCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.eduCourseCategory.children
                        delete this.eduCourseCategory.updateTime
                        post(`/edu/coursecategory/edit`, { ...this.eduCourseCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCategoryList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addEduCourseCategory() {
            this.showDialog = true;
            this.eduCourseCategoryState = 'add';
        },
        checkEduCourseCategory(eduCourseCategoryId) {
            console.log(eduCourseCategoryId);
            this.currentEduCourseCategoryId = eduCourseCategoryId;

            this.getEduCourseCategoryById();
            this.showDialog = true;
            this.eduCourseCategoryState = 'check';
        },
        editEduCourseCategory(eduCourseCategoryId) {
            console.log('eduCourseCategory', eduCourseCategoryId);
            if (eduCourseCategoryId) {
                this.currentEduCourseCategoryId = eduCourseCategoryId;
                this.getEduCourseCategoryById();
            } else {
                this.eduCourseCategory = { ...this.eduCourseCategory, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.eduCourseCategoryState = 'edit';
        },
        deleteEduCourseCategory(eduCourseCategoryId) {
            let ids = '';
            if (eduCourseCategoryId) {
                ids = eduCourseCategoryId;
            } else {
                ids = this.multipleSelection.map((eduCourseCategory) => eduCourseCategory.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/edu/coursecategory/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetEduCourseCategoryList();
                            this.getEduCourseCategoryList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        addChildCourseCategory(eduCourseCategoryId){
            this.addEduCourseCategory()
            this.eduCourseCategory.parentId = eduCourseCategoryId
        },
        refreshEduCourseCategoryList() {
            this.resetEduCourseCategoryList();
            this.getEduCourseCategoryList();
        },
        // getEduCourseCategoryList(query = {}) {
        //     this.loading = true;
        //     get(`/edu/coursecategory/findList`, {
        //         ...this.queryForm,
        //         pageNum: this.currentPage,
        //         pageSize: this.pageSize
        //     }).then((res) => {
        //         this.loading = false;
        //         if (res.success) {
        //             this.eduCourseCategoryList = res.page.list;
        //             this.totalNum = res.page.total;
        //         } else {
        //             this.$message({
        //                 message: res.msg,
        //                 type: 'error',
        //                 duration: 2000
        //             });
        //         }
        //     });
        // },
        getEduCourseCategoryList() {
            this.loading = true;
            get(`/edu/coursecategory/findAllAsTree`).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.eduCourseCategoryList = res.treeData;
                    this.totalNum = 1;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getEduCourseCategoryById() {
            get(`/edu/coursecategory/get`, { id: this.currentEduCourseCategoryId }).then((res) => {
                if (res.success) {
                    this.eduCourseCategory = { ...this.eduCourseCategory, ...res.eduCourseCategory };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportEduCourseCategoryList() {
            //this.btnLoading = true;
            exprotExcel(`/edu/coursecategory/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/edu/coursecategory/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/edu/coursecategory/importData`, formData);
            this.refreshEduCourseCategoryList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getEduCourseCategoryList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getEduCourseCategoryList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>